import React, { useEffect, useLayoutEffect, useState } from "react";

import { StepContainer, NavigationButtons, InfoBox } from "../index";

import { useWizard } from "../../wizard";

import { contentApi } from "../../services/contentApi";

import { contentKeys } from "../../constants/contentKeys";

const formatDate = (dateStr: string) => {
  const [y, m, d] = dateStr.split("-").map(Number);

  const date = new Date(y, m - 1, d);

  const months = [
    "januar",
    "februar",
    "marts",
    "april",
    "maj",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "december",
  ];

  return `${d}. ${months[m - 1]} ${y}`;
};

const BookingConfirmationStep: React.FC = () => {
  const { selfServiceData, sessionId, updateSelfServiceData } = useWizard();

  const [body, setBody] = useState<string[] | null>(null);

  useEffect(() => {
    contentApi
      .getByKey(contentKeys.tidsbestilling.bk_confirmation)
      .then((c) => {
        if (c?.body && c.body.length > 0) {
          setBody(c.body);
        }
      });
  }, []);

  useLayoutEffect(() => {
    updateSelfServiceData("isCompleted", true);
  }, [updateSelfServiceData]);

  const { date, time, locationName } = selfServiceData;

  return (
    <StepContainer title="Tid reserveret">
      {body ? (
        <InfoBox type="success">
          {body.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </InfoBox>
      ) : (
        <InfoBox type="success">
          <p>Tak. Din tid er reserveret. Du modtager en bekræftelse.</p>
        </InfoBox>
      )}

      {(locationName || date || time) && (
        <>
          <h3>Din reservation</h3>

          <ul className="summary-list">
            {locationName && (
              <li>
                <span className="label">Sted</span>

                <span className="value">{locationName}</span>
              </li>
            )}

            {date && (
              <li>
                <span className="label">Dato</span>

                <span className="value">{formatDate(date)}</span>
              </li>
            )}

            {time && (
              <li>
                <span className="label">Tid</span>

                <span className="value">kl. {time}</span>
              </li>
            )}
          </ul>
        </>
      )}

      <p style={{ marginTop: "2rem", fontSize: "0.85rem", color: "#d0d0d0" }}>
        <span style={{ opacity: 0.5 }}>
          <strong>Reference:</strong> {sessionId?.slice(-5) || ""}
        </span>
      </p>

      <NavigationButtons showBack={false} showNext={false} />
    </StepContainer>
  );
};

export default BookingConfirmationStep;
